import * as types from './actionTypes';
import client from 'helpers/client';
import cognito from 'helpers/cognito';
import Auth from '@aws-amplify/auth';
import paths from 'redux/paths';
import utils from 'helpers/utils';
import Utils from '../../helpers/utils';

const _utmTracking = async (user) => {
  const utmParams = JSON.parse(localStorage.getItem('utmParams'));
  if (!utmParams) return;
  utmParams.email = user.email;
  try {
    const data = await client.sendRequest({
      path: paths.SAVE_UTM_TRACKING,
      method: 'POST',
      params: utmParams,
      headers: await cognito.getHeaderAuthorization(),
    });
    localStorage.removeItem('utmParams');
    return data;
  } catch (error) {
    console.log('[_utmTracking]', error);
  }
};

export const fetchUser = (callback) => {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_USER });

    // To sure get currentUserCredentials correct on production environment when changing between minisites, we need to call twice
    let cred = await Auth.currentUserCredentials();
    cred = await Auth.currentUserCredentials();

    if (!cred || !cred.authenticated)
      return dispatch({
        type: types.FETCH_USER_FAILED,
        reason: 'Empty credential.',
      });

    const { authenticated, data } = cred;
    client
      .api('/user', 'get', { headers: await cognito.getHeaderAuthorization() })
      .then((res) => {
        const user = res.data.data;
        dispatch({
          type: types.FETCH_USER_SUCCESS,
          payload: {
            ...user,
            authenticated,
            credentials: data.Credentials,
          },
        });
        _utmTracking(user);
        callback && callback(user);
      })
      .catch((err) => {
        dispatch({
          type: types.FETCH_USER_FAILED,
          reason: err.message,
        });
      });
  };
};

export const fetchCodesOfUser =
  ({ page = 1, limit = 10 }) =>
    async (dispatch) => {
      try {
        dispatch({ type: types.FETCH_CODES_OF_USER });
        const { data: payload } = await client.sendRequest({
          path: `${paths.GET_TOKEN_PORTAL}?page=${page}&limit=${limit}`,
          method: 'GET',
          headers: await cognito.getHeaderAuthorization(),
        });
        dispatch({ type: types.FETCH_CODES_OF_USER_SUCCESS, payload });
        return payload;
      } catch (err) {
        dispatch({ type: types.FETCH_CODES_OF_USER_FAILED, reason: err.message });
      }
    };

export const setEditting = (value) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_EDITTING,
      payload: value,
    });
  };
};

export const updateUserInfo = (options = {}, callback) => {
  console.log('updateUserInfo called with options:', options);
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_USER,
    });

    try {
      const userData = localStorage.getItem('user-info');
      const userStorage = userData ? JSON.parse(userData) : null;
      if (!userStorage) {
        localStorage.removeItem('user-info');
        return dispatch({
          type: types.FETCH_USER_FAILED,
          reason: 'Empty credential.',
        });
      }
      console.log('User Storage:', userStorage);
      const headers = { 'authorization': userStorage.accessToken };
      console.log('Headers:', headers);

      // Thêm userStorage._id vào options
      options.userId = userStorage._id;

      const res = await client.sendRequest({
        path: '/mvp/buddy-update-profile-full',
        method: 'POST',
        params: options,
        headers: headers,
      });
      console.log('API Response:', res);

      dispatch({
        type: types.UPDATE_USER_SUCCESS,
        payload: res.data.data,
      });

      if (callback) {
        callback(res);
      }
    } catch (err) {
      console.error('API Error:', err);
      dispatch({
        type: types.UPDATE_USER_FAILED,
        reason: err.message,
      });
    }
  };
};
export const getUserProfileMvp = () => async (dispatch) => {
  try {
    const userData = localStorage.getItem('user-info');
    const userStorage = userData ? JSON.parse(userData) : null;
    if (!userStorage) {
      localStorage.removeItem('user-info');
      dispatch({
        type: types.FETCH_USER_FAILED,
        reason: 'Empty credential.',
      });
      return null;
    }
    console.log('User Storage:', userStorage);
    const headers = { 'authorization': userStorage.accessToken };
    console.log('Headers:', headers);

    const res = await client.sendRequest({
      path: `/mvp/buddy-profile/${userStorage._id}`,
      method: 'GET',
      headers: headers,
    });

    console.log('API Response:', res);
    dispatch({
      type: types.FETCH_USER_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    console.error('API Error:', err);
    dispatch({
      type: types.FETCH_USER_FAILED,
      reason: err.message,
    });
    return null;
  }
};


export const updateUserInfoBasic = (options = {}, callback) => {
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_USER,
    });
    client
      .api(paths.UPDATE_USER_BASIC, 'post', options, { headers: await cognito.getHeaderAuthorization() })
      .then((res) => {
        dispatch({
          type: types.UPDATE_USER_SUCCESS,
          payload: res.data.data,
        });
        callback && callback(res);
      })
      .catch((err) =>
        dispatch({
          type: types.UPDATE_USER_FAILED,
          reason: err.message,
        }),
      );
  };
};

export const updateProfilePicture = (pictureUri) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_PROFILE_PICTURE });
    const { data = {} } = await client.sendRequest({
      path: paths.UPDATE_PROFILE_PICTURE,
      method: 'POST',
      params: { avatarUrl: pictureUri },
      headers: await cognito.getHeaderAuthorization(),
    });
    dispatch({
      type: types.UPDATE_PROFILE_PICTURE_SUCCESS,
      avatarUrl: data.avatarUrl,
    });
  } catch (err) {
    dispatch({
      type: types.UPDATE_PROFILE_PICTURE_FAILED,
      reason: err.message,
    });
  }
};

export const updateKATAddress = (katAddress, callback) => {
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_KAT_ADDRESS,
    });

    client
      .api(
        '/user/update-kat-address',
        'post',
        { katAddress: katAddress },
        { headers: await cognito.getHeaderAuthorization() },
      )
      .then((res) => {
        dispatch({
          type: types.UPDATE_KAT_ADDRESS_SUCCESS,
          payload: res.data.data,
        });
        callback && callback(res);
      })
      .catch((err) =>
        dispatch({
          type: types.UPDATE_KAT_ADDRESS_FAILED,
          reason: err.message,
        }),
      );
  };
};

export const uploadImage = (data, callback) => {
  return async (dispatch) => {
    dispatch({ type: types.UPLOAD_IMAGE });

    client
      .api('/image/upload', 'post', data, { headers: await cognito.getHeaderAuthorization() })
      .then(function (res) {
        const imageUrl = res.data.data.imageLink;
        dispatch({
          type: types.UPLOAD_IMAGE_SUCCESS,
          payload: imageUrl,
        });
        callback && callback(null, imageUrl);
      })
      .catch((err) => {
        dispatch({
          type: types.UPLOAD_IMAGE_FAILED,
        });
        callback && callback(err);
      });
  };
};

export const linkProvider = (headers, callback) => {
  return async (dispatch) => {
    client
      .api('/cognito/link-provider', 'post', null, { headers: headers })
      .then(function (res) {
        callback && callback(null);
      })
      .catch((err) => {
        callback && callback(err);
      });
  };
};

export const fetchAllReferences = () => async (dispatch, getState) => {
  try {
    dispatch({ type: types.FETCH_ALL_REFERENCES });

    const { references } = getState().user;
    const fileNames = [
      'collaborativeTools',
      'databases',
      'languages',
      'miscTools',
      'os',
      'platforms',
      'webFrameworks',
      'schools',
      'majors',
      'organizations',
      'roles',
    ];

    const getPromises = fileNames
      .filter((fileName) => !references[fileName])
      .map((fileName) => {
        return new Promise((resolve, reject) => {
          client
            .api(
              `https://kambria-static.s3-ap-southeast-1.amazonaws.com/userprofile/references/${fileName}.json`,
              'GET',
            )
            .then(({ data }) => {
              data = data.map((value) => ({ label: value, value }));
              dispatch({
                type: types.UPDATE_REFERENCE,
                payload: { [fileName]: data },
              });
              resolve();
            })
            .catch(reject);
        });
      });
    await Promise.all(getPromises);
    // type technology category fix cung du lieu tam thoi
    const technologyCategory = [
      { label: 'AI', value: 'AI' },
      { label: 'Robotics', value: 'Robotics' },
      { label: 'Blockchain', value: 'Blockchain' },
      { label: 'IoT', value: 'IoT' }
    ]
    const fileNameTechnologyCategory = 'technologyCategory'
    await dispatch({
      type: types.UPDATE_REFERENCE,
      payload: { [fileNameTechnologyCategory]: technologyCategory },
    });
    dispatch({ type: types.FETCH_ALL_REFERENCES_SUCCESS });
  } catch (err) {
    dispatch({ type: types.FETCH_ALL_REFERENCES_FAILED, error: err.message });
  }
};

export const checkPublicUsername = (publicUsername) => async (dispatch) => {
  try {
    dispatch({ type: types.CHECK_PUBLIC_USERNAME });
    const data = await client.sendRequest({
      path: paths.CHECK_PUBLIC_USERNAME,
      method: 'POST',
      params: { publicUsername },
      headers: await cognito.getHeaderAuthorization(),
    });
    dispatch({ type: types.CHECK_PUBLIC_USERNAME_SUCCESS, payload: data });
    return data;
  } catch (err) {
    dispatch({ type: types.CHECK_PUBLIC_USERNAME_FAILED, error: err.message });
  }
};

export const checkAWSUser = (email) => async () => {
  try {
    console.log("email", email)
    const data = await client.sendRequest({
      path: paths.CHECK_AWS_USERNAME,
      method: 'POST',
      params: { email }
    });
    return data;
  } catch (err) {
    return null;
  }
};

export const updateEmailToSendy = (email) => async () => {
  try {
    const data = await client.sendRequest({
      path: paths.SUBSCRIBE_SENDY,
      method: 'POST',
      params: { email },
      //headers: await cognito.getHeaderAuthorization(),
    });
    return data;
  } catch (err) {
    return null;
  }
}


export const mvpRefreshToken = () => async (dispatch) => {
  try {
    const refreshToken = await utils.getCookie('_RFT')
    if (!refreshToken) {
      return null
    }
    const headers = { 'authorization': refreshToken };
    const data = await client.sendRequest({
      path: `/mvp/refresh-token`,
      method: 'POST',
      headers: headers,
    });

    if (data.status == 'OK') {
      const user = {
        statusVerify: data.user.statusVerify,
        type: data.user.type,
        name: data.user.name,
        _id: data.user._id,
        accessToken: data.accessToken
      }

      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          ...user,
          authenticated: true,
          credentials: data.Credentials,
          token: data.accessToken,
        },
      });

      localStorage.setItem('user-info', JSON.stringify(user));
      utils.saveToCookie('_RFT', data.refreshToken, 365)
      const redirectTo = sessionStorage.getItem('previousUrl') || '/';
      sessionStorage.removeItem('previousUrl');
      window.location.href = redirectTo;
    }

    return null
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
};

export const verifyBySignIn = (email, password) => async () => {
  try {
    return await client.sendRequest({
      path: paths.MVP_LOGIN,
      method: 'POST',
      params: { email, password },
    })
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
}

export const changePassword = (email, password, password2) => async (dispatch) => {
  try {
    const data = await client.sendRequest({
      path: paths.CHANGE_PASSWORD,
      method: 'POST',
      params: { email, password, password2 },
    })
    if (data.status === 'OK') {
      const user = {
        name: data.user.name,
        _id: data.user._id,
        accessToken: data.accessToken
      }

      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          ...user,
          authenticated: true,
          credentials: data?.Credentials,
          token: data.accessToken,
        },
      });
    }
    return data
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
}

export const logInMvp = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: types.FETCH_USER });
    const data = await client.sendRequest({
      path: paths.MVP_LOGIN,
      method: 'POST',
      params: { email, password },
    })
    if (data.status == 'OK') {
      const user = {
        name: data.user.name,
        _id: data.user._id,
        accessToken: data.accessToken
      }

      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          ...user,
          authenticated: true,
          credentials: data.Credentials,
          token: data.accessToken,
        },
      });
    }
    return data;
  } catch (err) {

    return { status: 'not-ok', message: err.message }
  }
}

export const getListLanguage = () => async (dispatch, getState) => {
  try {
    const { accessToken } = getState().user;
    const response = await client.sendRequest({
      path: paths.LIST_LANGUAGE,
      method: 'GET',
      // headers: { 'authorization': accessToken }
    })
    let data = null;
    if (response.status === 'OK') {
      data = response.data

      dispatch({
        type: types.MVP_GET_LIST_LANGUAGE,
        data
      });
    }
    return data;
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
}

export const changeLanguage = (language) => async (dispatch, getState) => {
  if (!language) {
    return
  }
  try {
    const user = getState().user;
    await client.sendRequest({
      path: paths.CHANGE_LANGUAGE,
      method: 'POST',
      params: { language },
      headers: { 'authorization': user.accessToken }
    })
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
}

export const fetchUserMvp = (callback) => {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_USER });

    const userData = localStorage.getItem('user-info')
    const userStorage = userData ? JSON.parse(userData) : null;
    if (!userStorage) {
      localStorage.removeItem('user-info')
      return dispatch({
        type: types.FETCH_USER_FAILED,
        reason: 'Empty credential.',
      });
    }

    client.sendRequest({
      path: '/mvp/me',
      method: 'POST',
      params: {},
      headers: { 'authorization': userStorage.accessToken },
    }).then((data) => {
      if (data.status == 'OK') {
        const user = {
          name: data.user.name,
          email: data.user.email,
          walletAddress: data.user.walletAddress,
          _id: data.user._id,
          accessToken: userStorage.accessToken,
          type: data.user.type,
          language: data.user.language,
          statusVerify: data.user.statusVerify
        }

        dispatch({
          type: types.FETCH_USER_SUCCESS,
          payload: {
            ...user,
            authenticated: true,
            credentials: data.Credentials,
            accessToken: userStorage.accessToken,
            wallet: data.user.wallet,
          },
        });
        localStorage.setItem('user-info', JSON.stringify(user))
      }
    })
      .catch((err) => {
        dispatch({
          type: types.FETCH_USER_FAILED,
          reason: err.message,
        });
      });
  };
};

export const logOutMvp = (accessToken) => async (dispatch) => {
  try {
    dispatch({ type: types.FETCH_USER });
    Utils.removeCookie('_RFT')
    const data = await client.sendRequest({
      path: 'mvp/sign-out',
      method: 'POST',
      params: {},
      headers: { 'authorization': accessToken },
    })
    if (data.status == 'OK') {
      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          user: null,
          authenticated: false,
          credentials: null,
          token: null
        },
      });
    }
    return data;
  } catch (err) {
    return null
  }
}

export const getBuddyYouthCommunity = () => async () => {
  try {
    const data = await client.sendRequest({
      path: paths.LIST_YOUTH_COMMUNITY,
      method: 'GET',
    })
    if (data.status !== 'OK') {
      return null
    }
    return data.data
  } catch (e) {
    return null
  }
}

export const getActiveCode = (email, password, type, name, giftCode) => async () => {
  try {
    const data = await client.sendRequest({
      path: paths.GET_ACTIVE_CODE,
      method: 'POST',
      params: { email, password, type, name, giftCode },
    })
    return data
  } catch (err) {
    return { status: 'ERROR', message: err.message, type: err?.type }
  }
}

export const mvpSignUp = (params) => async (dispatch) => {
  try {
    const data = await client.sendRequest({
      path: paths.SIGN_UP,
      method: 'POST',
      params: params
    })
    if (data.status === 'OK') {
      const user = {
        name: data.user.name,
        _id: data.user._id,
        accessToken: data.accessToken
      }
      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          ...data.user,
          authenticated: true,
          token: data.accessToken,
        },
      });
    }
    return data
  } catch (err) {
    return { status: 'ERROR', message: err.message }
  }
}
